import { useAuth0 } from "@auth0/auth0-react"
import { useAppSelector } from '../../app/hooks'
import { BackButton } from './BackButton'
import { SaveEventTaskButton } from '../currentEventTask/SaveEventTaskButton'
import { 
    selectBackButtonVisible,
    selectAddPartyEventVisible,
    selectSavePartyEventVisible,
    selectAddEventTaskVisible, 
    selectSaveEventTaskButtonVisible,
    selectAddEventUserButtonVisible,
    selectSaveEventUserButtonVisible,
    selectInformationButtonVisible,
    selectHomeButtonVisible,
    selectReloadButtonVisible,
    selectNotificationReloadButton
} from './menuSlice'
import { HomeButton } from "./HomeButton"
import { AddEventTaskButton } from '../currentPartyEvent/AddEventTaskButton'
import { AddPartyEventButton } from '../partyEvents/AddPartyEventButton'
import { SavePartyEventButton } from '../partyEvents/SavePartyEventButton'
import { AddEventUserButton } from  "../addEventUser/AddEventUserButton"
import { SaveEventUserButton } from "../addEventUser/SaveEventUserButton"
import { InformationButton } from "../compliance/InformationButton"
import styles from './Menu.module.css';
import { ReloadButton } from "./ReloadPartyEventsButton"
import { ReloadNotificationButton } from "./ReloadNotificationsButton"


export function Menu() {
    const { isAuthenticated } = useAuth0()
    const backButtonVisible = useAppSelector(selectBackButtonVisible)
    const addPartyEventVisible = useAppSelector(selectAddPartyEventVisible)
    const savePartyEventVisible = useAppSelector(selectSavePartyEventVisible)
    const addEventTaskVisible = useAppSelector(selectAddEventTaskVisible)
    const saveEventTaskButtonVisible = useAppSelector(selectSaveEventTaskButtonVisible)
    const addEventUserButtonVisible = useAppSelector(selectAddEventUserButtonVisible)
    const saveEventUserButtonVisible = useAppSelector(selectSaveEventUserButtonVisible)
    const informationButtonVisible = useAppSelector(selectInformationButtonVisible)
    const homeButtonVisible = useAppSelector(selectHomeButtonVisible)
    const reloadButtonVisible = useAppSelector(selectReloadButtonVisible)
    const notificationReloadButtonVisible = useAppSelector(selectNotificationReloadButton)
    return(
        <div className={styles.menuPanel}>
            { isAuthenticated && homeButtonVisible ? <HomeButton/> : null}
            { isAuthenticated && backButtonVisible ? <BackButton /> : null }
            { isAuthenticated && addPartyEventVisible ? <AddPartyEventButton /> : null }
            { isAuthenticated && savePartyEventVisible ? <SavePartyEventButton/> : null }
            { isAuthenticated && addEventTaskVisible ? <AddEventTaskButton /> : null }
            { isAuthenticated && saveEventTaskButtonVisible ? <SaveEventTaskButton /> : null }
            { isAuthenticated && addEventUserButtonVisible ? <AddEventUserButton /> : null } 
            { isAuthenticated && saveEventUserButtonVisible ? <SaveEventUserButton /> : null } 
            { isAuthenticated && informationButtonVisible ? <InformationButton/> : null} 
            { isAuthenticated && reloadButtonVisible ? <ReloadButton/> : null}
            { isAuthenticated && notificationReloadButtonVisible ? <ReloadNotificationButton/> : null}
        </div>
    )
}